
















































import { Component, Vue, Prop } from "vue-property-decorator";
import VueTagsInput from "@johmun/vue-tags-input";
import { TYPE_INVITATION } from "@/resources/constants/invitation";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
@Component({
  name: "invitation-form-education-component",
  components: {
    VueTagsInput,
  },
})
export default class InvitationFormEducationComponent extends mixins(
  NotificationEvent
) {
  @Prop() updateInvitationSelected: number;
  TYPE_INVITATION = TYPE_INVITATION;
  email = "";
  emails = [];
  type = "";
  types = [
    { name: i18n.t("education.teacher"), value: "TEACHER" },
    { name: i18n.t("education.student"), value: "STUDENT" },
    { name: i18n.t("education.staff"), value: "STAFF" },
  ];
  language = i18n.locale;
  loading = false;
  get invitationSelected(): number {
    return this.updateInvitationSelected;
  }
  set invitationSelected(e) {
    this.$emit("updateInvitationSelected", e);
  }
  addEmail(e) {
    const regEmail = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
    const auxEmail = [];

    for (const emails of e) {
      emails.text.replace(" ", ",");
      const caseEmail = emails.text.split(",");
      for (const email of caseEmail) {
        if (regEmail.test(email) && auxEmail.indexOf(email) < 0) {
          auxEmail.push({
            text: email,
            tiClasses: ["ti-valid"],
          });
        }
      }
    }
    this.emails = auxEmail;
  }

  checkDisabled() {
    if (this.emails.length > 0 && this.type.length > 0 || this.loading) {
      return false;
    }
    return true;
  }
  sendInvitations(): void {
    const emails = this.emails.map((a) => a.text);
    this.loading = true;
    this.$store.dispatch("UserStore/sendInvitationsAction", {
      data: {
        space: this.$store.getters["SpaceStore/getSpace"].id,
        type: "TARGET_USER_INVITATION",
        room: null,
        hasOnboarding: false,
        language: this.language,
        domain: "HAWKINGS",
        emails,
        hawkingsType: this.type,
      },
      callback: (response) => {
        this.loading = false;
        if (response.status == "KO") {
          response.message.forEach((element) => {
            const error = element.split(":");
            this.onWarning(
              "",
              error[0] + " " + this.getTextError(error[1]),
              "none"
            );
          });
        }
        if (response.status == "OK") {
          this.emails = [];
          this.type = "";
          this.onSuccess(
            this.$i18n.t("notifications.titles.success"),
            this.$i18n.t("notifications.descriptions.sendInvitations")
          );
        }
      },
      callbackError: (error) => {
        this.loading = false;
        this.onError(
          this.$i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.genericError.genericErrorRetry"),
          "none"
        );
      },
    });
  }
  getTextError(text: string): string {
    //Todo Cambiar cuando se manden las traduciones desde la api.
    const a = "This user already belong to this space";
    const b = "Guest users are not allowed to use user invitation";
    if (text.includes("Guest"))
      return this.$i18n
        .t("notifications.warningMessages.emailErrorGuest")
        .toString();
    if (text.includes("already"))
      return this.$i18n
        .t("notifications.warningMessages.emailInSpace")
        .toString();
  }
}
